import React from 'react';
import style from '../../style.scss';
import translations from '../../translations';
import {
    useDynamicReducerSelector
} from '../../state';
import useTranslate from '../../hooks/useTranslate';
import Timer from '../../components/Timer';
import { isNotStarted, isActive, isCompleted } from '../../network';
import classNames from '../../common/classNames';

const statusNotJoined = {
    statusStyle: style.logoNotJoined,
    title: translations.statusNotJoined,
    description: translations.statusNotJoinedDescription
};
const statusJoined = {
    statusStyle: style.logoJoined,
    title: translations.statusJoined,
    description: translations.statusJoinedDescription
};
const statusNotEligible = {
    statusStyle: style.logoNotEligible,
    title: translations.statusNotEligible,
    description: translations.statusNotEligibleDescription
};
const statusEligible = {
    statusStyle: style.logoEligible,
    title: translations.statusEligible,
    description: translations.statusEligibleDescription
};
const statusCompleted = {
    statusStyle: style.logoCompleted,
    title: translations.statusFinished,
    description: translations.statusCompletedDescription
};
const statusGetParcel = {
    statusStyle: style.logoCompleted,
    title: translations.statusYouHaveTheParcel,
    description: translations.statusYouHaveTheParcelDescription
};
const statusDefault = { statusStyle: '', title: translations.empty, description: translations.empty };

export default ({ customStyle, isShowPossessionInfo, onCLickNotEligible }) => {
    const status = useDynamicReducerSelector(state => state.status);
    const { joined } = useDynamicReducerSelector(state => state.join);
    const eligible = useDynamicReducerSelector(state => state.eligible);
    const startTime = useDynamicReducerSelector(state => state.eventStartTime);
    const statusDelay = useDynamicReducerSelector(state => state.statusDelay);

    const t = useTranslate();

    const isNotParcelStarted = isNotStarted(status);
    const isParcelActive = isActive(status);
    const isParcelEnded = isCompleted(status);

    const selectStatusState = () => {
        if (isShowPossessionInfo) {
            return statusGetParcel;
        }
        if (status === '' || statusDelay) {
            return statusDefault;
        }

        if (isNotParcelStarted) {
            if (joined) {
                return statusJoined;
            }
            return statusNotJoined;
        }

        if (isParcelEnded) {
            return statusCompleted;
        }

        if (isParcelActive) {
            if (!joined) {
                return statusNotJoined;
            }
            if (eligible) {
                return statusEligible;
            }
            return statusNotEligible;
        }
        return statusDefault;
    };

    const stateStatus = selectStatusState();
    const isNotEligible = () => {
        return isParcelActive && joined && !eligible;
    };
    const onEligibleStatusClick = () => {
        if (isNotEligible() && !isShowPossessionInfo) {
            onCLickNotEligible();
        }
    };

    return <div className={classNames(customStyle)}>
        <div className={classNames(style.statusWrapper, { [style.clickable]: isNotEligible() && !isShowPossessionInfo })}
             onClick={onEligibleStatusClick}>
            <div className={stateStatus.statusStyle}/>
            <div className={style.panelCellLeft}>
                <div className={style.textBlockLeftAligned}>
                        <span className={style.panelMainText}>
                            {t(stateStatus.title)}
                        </span>
                    <span className={style.panelText}>
                            {t(stateStatus.description)}
                        {isNotParcelStarted && joined &&
                        <Timer timeStamp={startTime} format={'HHh_MMm_SSs'} className={style.boltText}/>}
                        </span>
                </div>
            </div>
        </div>
    </div>;
};
